import { render } from "./FileItem.vue?vue&type=template&id=f3e6e742&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=f3e6e742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e6e742"]])

export default __exports__